import React from 'react';
import styled from 'styled-components/macro';
import leftImage from '../resources/images/chevron.left.svg';

interface Props {
	title: string;
	location?: number;
	setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
}

const BackNavBar = ({ title, location, setCurrentPage }: Props) => {
	return (
		<StyledBackBar>
			{' '}
			{location && (
				<StyledBackImage
					src={leftImage}
					onClick={() => {
						setCurrentPage(location);
					}}
				/>
			)}{' '}
			<StyledHeading>{title}</StyledHeading>{' '}
		</StyledBackBar>
	);
};

const StyledBackBar = styled.div`
	position: relative;
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100%;
	height: 56px;
	background: #f4f4f4;
`;

const StyledBackImage = styled.img`
	position: absolute;
	left: 20px;
	width: 11.412px;
	height: 19.878px;
	cursor: pointer;
`;

const StyledHeading = styled.h1`
	color: #333333;
	font-size: 16px;
	font-style: normal;
	font-weight: 600;
	line-height: 19px;
`;

export default BackNavBar;
